export class DictionaryValues {
  [index: string]: string;
}

export class Configuration {
  application: Application;
  businessModel: BusinessModel;
}

export class Application {
  displayName: TranslatedName;
  virtualApplications?: (VirtualApplicationsEntity)[] | null;
  modules?: (ModulesEntity)[] | null;
  functions?: FunctionDesc[];
  accessList?: null;
}

export class TranslatedName {
  name: string;
}

export class VirtualApplicationsEntity {
  displayName: TranslatedName;
  dataSourceLimiters?: null;
  id: string;
}

export class ModulesEntity {
  displayName: TranslatedName;
  functions?: FunctionDesc[];
  accessList?: null;
  id: string;
}

export class Functions {
  nodes?: (NodesEntity)[] | null;
}

export class NodesEntity {
  value?: Value | null;
  displayName: TranslatedName;
  icon?: null;
  id: string;
  nodes?: (NodesEntity)[] | null;
  expanded: boolean;
}

export class Value {
  displayName?: null;
  action: Action;
  accessList?: null;
  location: number;
  report: boolean;
  id: string;
}

export abstract class Action {
  id: string;
  actionType: string;
  inputParams: any;
}

export class ElementAction extends Action {
  elementId: string;
  elementViewId: string;
  iconCls?: null;
  functionName: string;
}

export class ExternalElementAction extends Action {
  elementId?: string | null;
  elementViewId?: string | null;
  iconCls?: string | null;
  functionName?: string | null;
  featureKey?: string | null;
}

export class AssemblyAction extends Action {
  assemblyLocation: string;
  assemblyName: string;
  className: string;
  methodName: string;
  returnType: string;
  headerMediaReturnType: string;
}

export class RestServiceAction extends Action {
  serviceUrl: string;
  method: number;
  openInNewWindow: boolean;
  parameters?: (RestServiceParameter)[] | null;
}

export class RestServiceParameter {
  parameterName: string;
  sourceAttributeViewId: string;
}

export class ParameterAction extends Action {
  parameterActionType: number;
  parameterType: number;
  destinationElementId: string;
  destinationAttributeId: string;
  destParameterAttributeId: string;
}

export class CustomAction extends Action {
  functionName: string;
}

export class CustomDialogAction extends CustomAction {
  title: TranslatedName;
  name: string;
  functions: FunctionDesc[];
  attributes: AttributesEntity[];
}

export class StaticValueFillAction extends CustomAction {
  value: string;
  id: string;
}

export class NodesEntity1 {
  value?: Value1 | null;
  displayName: TranslatedName;
  icon?: null;
  id: string;
  nodes?: (NodesEntity2)[] | null;
}

export class Value1 {
  displayName?: null;
  action?: Action | null;
  accessList?: null;
  location: number;
  report: boolean;
  id: string;
  reportType?: string | null;
}

export class NodesEntity2 {
  value: Value2;
  displayName: TranslatedName;
  icon?: null;
  id: string;
}

export class Value2 {
  displayName?: null;
  action: Action;
  accessList?: null;
  location: number;
  report: boolean;
  id: string;
}

export class BusinessModel {
  dataSources?: (DataSourcesEntity)[] | null;
  elements?: (ElementsEntity)[] | null;
  logicalView: LogicalView;
  reports?: (ReportsEntity)[] | null;
}

export class DataSourcesEntity {
  id: string;
  connectionString: string;
}

export class ElementsEntity {
  displayName?: DisplayNameOrSourceDefinitionOrAttributeName1 | null;
  search?: Search | null;
  functions?: null;
  attributes?: (AttributesEntity)[] | null;
  relations?: (RelationsEntity)[] | null;
  genericElementViews?: (GenericElementViewsEntity)[] | null;
  elementViews?: (ElementViewsEntity)[] | null;
  sourceDefinition: SourceDefinition;
  accessList?: null;
  filter?: Filter | null;
  id: string;
}

export class DisplayNameOrSourceDefinitionOrAttributeName1 {
  name: string;
}

export class Search {
  descriptionAttributeId: string;
  imageAttributeId?: null;
  coordsAttributeId?: null;
  obiektAttributeId?: null;
}

export class AttributesEntity {
  displayName: TranslatedName;
  businessType: number;
  accessList?: AccessList | null;
  sourceDefinition: SourceDefinition1;
  search: boolean;
  basic: boolean;
  chart: boolean;
  primaryKey: boolean;
  id: string;
  displayMode: number;
  businessModelElementAttrId: string;
  autoFillFunction?: AutoFillFunction | null;
  relationFunction?: RelationFunction | null;
  required: boolean;
  value: string;
  dirValue: string;
  order: number;
}

export class SourceDefinition1 {
  name?: string | null;
  expression?: string | null;
  orderBy?: string | null;
  whereClauseColumn?: string | null;
  expressionField?: string | null;
  dictionaryElement?: string | null;
  foregnKeyColumn?: string | null;
  dictionaryElementKeyAttribute?: string | null;
  dictionaryElementValueAttribute?: string | null;
  dictionaryElementDescriptionAttribute?: string | null;
  autocomplete?: boolean | null;
}

export class RelationsEntity {
  relatedElementId: string;
  relationRule: RelationRule;
  id: string;
}

export class RelationRule {
  sourceAttributeId: string;
  destinationAttributeId: string;
  crossTableDestinationAttributeId?: string | null;
  crossTableSourceAttributeId?: string | null;
  crossElementId?: string | null;
}

export class GenericElementViewsEntity {
  rowFunctions?: RowFunction[] | null;
  displayName?: DisplayNameOrSourceDefinitionOrAttributeName2 | null;
  sourceDefinition?: null;
  configuration?: null;
  // functions?: Functions1 | null;
  functions?: FunctionDesc[] | null;
  attributes?: (AttributesEntity)[] | null;
  relationViews?: (RelationViewsEntity)[] | null;
  accessList?: null;
  details: boolean;
  id: string;
  viewType: number;
  displayMode: number;
}

export class NodesEntity3 {
  value: Value3;
  displayName: TranslatedName;
  icon?: null;
  id: string;
}

export class Value3 {
  displayName?: null;
  action: ExternalElementAction;
  accessList?: null;
  location: number;
  report: boolean;
  id: string;
}

export class DisplayNameOrSourceDefinitionOrAttributeName2 {
  name: string;
}

export class Functions1 {
  nodes?: (NodesEntity4)[] | null;
}

export class NodesEntity4 {
  value: Value4;
  displayName: TranslatedName;
  icon?: null;
  id: string;
}

export class Value4 {
  displayName?: null;
  action?: ExternalElementAction | null;
  accessList?: null;
  location: number;
  report: boolean;
  id: string;
}

export class DisplayNameOrSourceDefinitionOrAttributeName3 {
  name: string;
}

export class AccessList {
  roleIds?: (string)[] | null;
}

export class FunctionDesc {
  id: string;
  accessList?: AccessList;
  action: Action;
  displayName?: TranslatedName;
  location: number;
  report: boolean;
  isGroup: boolean;
  order: number;
  customServiceName: string;
  expanded: boolean;
  functions: FunctionDesc[];
  notificationCount: number;
}

export class AutoFillFunction extends FunctionDesc {
  action: StaticValueFillAction;
}

export class RowFunctionFilter {
  filteringField: string;
  filteringExpression: string;
  prevOperator: string;
}

export class RowFunction extends FunctionDesc {
  filters: RowFunctionFilter[];
}

export class RelationFunction extends RowFunction {
  sourceAttributeViewId: string;
}

export class RelationViewsEntity {
  displayName: TranslatedName;
  relatedElementViewId: string;
  sourceElementViewId: string;
  relationId: string;
  actionId: string;
  relatedElementId: string;
  sourceElementId: string;
  accessList?: null;
  id: string;
}

export class ElementViewsEntity {
  elementViewType: string;
  displayName: TranslatedName;
  sourceDefinition?: null;
  configuration?: null;
  functions?: null;
  attributes?: null;
  relationViews?: null;
  accessList?: null;
  details: boolean;
  id: string;
}

export class SourceDefinition {
  dataSourceId: string;
  objectName: string;
  filter?: null;
}

export class Filter {
  descriptionAttributeId: string;
  attributeName: TranslatedName;
}

export class LogicalView {
  nodes?: (NodesEntity5)[] | null;
}

export class NodesEntity5 {
  value: Value5;
  displayName?: null;
  icon?: null;
  id: string;
}

export class Value5 {
  elementViewId: string;
  id: string;
}

export class ReportsEntity {
  id: string;
  title: string;
  outputFormat: string;
  columns?: (ColumnsEntity)[] | null;
  mainTableId: MainTableId;
  joinedTables?: (JoinedTablesEntity)[] | null;
  type: string;
  horizontal: boolean;
  elementAttrDateId?: string | null;
  attrDateId?: string | null;
}

export class ColumnsEntity {
  id: string;
  elementId?: string | null;
  attributeId?: string | null;
  displayName: TranslatedName;
  toSummaryRow: boolean;
  type: string;
  subColumns?: (ColumnsEntityOrSubColumnsEntity)[] | null;
}

export class ColumnsEntityOrSubColumnsEntity {
  id: string;
  elementId: string;
  attributeId: string;
  displayName: TranslatedName;
  toSummaryRow: boolean;
  type: string;
}

export class MainTableId {
  id: string;
}

export class JoinedTablesEntity {
  elementId: string;
  relation: RelationsEntityOrRelation;
}

export class RelationsEntityOrRelation {
  relatedElementId: string;
  relationRule: RelationRule1;
  id: string;
}

export class RelationRule1 {
  sourceAttributeId: string;
  destinationAttributeId: string;
}



// WEBPACK FOOTER //
// ./src/app/models/configuration.model.ts